const bages = {
  hard: {text: "hard", textColor:"gray", borderColor:"#E8E8E8", signOn: true, signColor: "red"}
}

export default bages
